import { evalCondition } from 'mailup-react-helpers'
import {
  Flex,
  FORM_ELEMENT_SPACING_SMALL,
  FormElement,
  IconLock,
  InputText,
  TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS,
  TrustedEmailInput
} from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'

import styled from '@emotion/styled'
import useTrustedEmailSender, {
  trustedEmailSenderState
} from 'Hooks/useTrustedEmailSender/useTrustedEmailSender'
import { senderInfoState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'

const InputSenderEmail = () => {
  const intl = useIntl()
  const [
    { isPEC, senderEmail, customSender, fetchedSender, waitForVerified },
    setSenderState
  ] = useRecoilState(senderInfoState)
  const setTrustedEmailState = useSetRecoilState(
    trustedEmailSenderState('trustedSender')
  )

  const trustedSenderProps = useTrustedEmailSender(
    'trustedSender',
    senderEmail,
    true
  )

  const isWL = evalCondition('co:WHITELABEL')

  useEffect(() => {
    if (!fetchedSender && !isPEC) {
      setTrustedEmailState(prev => ({
        ...prev,
        value: senderEmail || undefined
      }))
      setSenderState(prev => ({
        ...prev,
        fetchedSender: true
      }))
    }
  }, [fetchedSender, senderEmail, isPEC])

  useEffect(() => {
    fetchedSender &&
      setSenderState(prev => ({
        ...prev,
        senderEmail: trustedSenderProps.value,
        savedAsDefault:
          prev.savedAsDefault === trustedSenderProps.value
            ? prev.savedAsDefault
            : undefined
      }))
  }, [trustedSenderProps.value])

  useEffect(() => {
    if (
      waitForVerified &&
      trustedSenderProps.variant === TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS
    ) {
      setSenderState(prev => ({
        ...prev,
        waitForVerified: false,
        senderIsDeleted: false
      }))
    }
  }, [trustedSenderProps.variant])

  return (
    <>
      {isPEC ? (
        <>
          <FormElement
            required
            label={intl.formatMessage({ id: 'Load.Common.SenderEmailLabel' })}
            labelHelp={intl.formatMessage({
              id: 'Load.PecPlus.AltImgMailMittPec'
            })}
            labelSpacing={FORM_ELEMENT_SPACING_SMALL}
          >
            <StyledFlex
              data-tip={intl.formatMessage({
                id: isWL
                  ? 'Load.PecPlus.senderPecTooltipWL'
                  : 'Load.PecPlus.senderPecTooltip'
              })}
            >
              <IconLock className='icon' />
              <InputText placeholder={senderEmail} disabled />
            </StyledFlex>
          </FormElement>
        </>
      ) : (
        <>
          <FormElement
            required
            label={
              customSender
                ? intl.formatMessage({
                    id: 'Load.EmailSendingWizard.DefaultSenderEmailLabel'
                  })
                : intl.formatMessage({
                    id: 'Load.Common.SenderEmailLabel'
                  })
            }
            labelHelp={intl.formatMessage({
              id: 'Load.Common.SenderEmailTooltip'
            })}
            labelSpacing={FORM_ELEMENT_SPACING_SMALL}
          >
            <div data-mu-test='sending-wizard-input-sender-email'>
              <TrustedEmailInput
                id='trustedSender'
                disabled={evalCondition('uo:EMAILSENDERLOCKED')}
                {...trustedSenderProps}
              />
            </div>
          </FormElement>
        </>
      )}
    </>
  )
}

export default InputSenderEmail

const StyledFlex = styled(Flex)`
  :hover {
    border-radius: 6px;
    outline: 1px solid var(--bombay);
  }
  .icon {
    padding: 10px;
    color: black;
    text-align: center;
    border-radius: 4px;
    border-top: 1px solid var(--geyser);
    border-left: 1px solid var(--geyser);
    border-bottom: 1px solid var(--geyser);
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    height: 36px;
    flex-basis: 36px;
    opacity: 0.4;

    :hover {
      border: none !important;
    }
  }

  .e-input-text {
    flex-grow: 1;

    &__input {
      border-left: 0 !important;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;

      :hover {
        border: none !important;
      }
    }
  }
`
